import { render } from "./ViewsImpersonation.vue?vue&type=template&id=8c683d7a"
import script from "./ViewsImpersonation.vue?vue&type=script&lang=js"
export * from "./ViewsImpersonation.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__